import { render, staticRenderFns } from "./VuePaycard.vue?vue&type=template&id=235907e4&scoped=true"
import script from "./VuePaycard.vue?vue&type=script&lang=js"
export * from "./VuePaycard.vue?vue&type=script&lang=js"
import style0 from "../assets/css/style.min.css?vue&type=style&index=0&id=235907e4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235907e4",
  null
  
)

export default component.exports